module.exports = __webpack_public_path__ + "img/stripe-slate.abb777ef.svg";